/*
Ashraf 01/31/2023 2699714747 Added sort fields table
Ashraf 02/06/2023 2698959212 fixed sort fields duplicate issue
Raghu 02/23/2023 2698959212 fixed new Ui changes
Akhila 06/08/2023 2698959212 created date change to date created field and column
Ravi 07/19/2023 2698959212 modifield sort field popup
*/
import React, {useEffect, useState, useContext, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  getBaseCategory,
  getFieldType,
  resetData,
} from '../../../../../../redux/reducers/GlobalField/AddFieldList';
import {Button} from '@material-ui/core';
import {Form, Formik} from 'formik';
import ErrorBoundaryForComponents from '../../../../../../util/ErrorBoundaryForComponents';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import FieldListSearchTable from './sortFieldsTable';
import {WarningSnackbar} from '../../../../../../components/CustomSnackBar';
import {
  fetchExistingDataRepositoryNames,
  resetDataRepo,
} from '../../../../../../redux/reducers/GlobalField/DataRepository';
import SelectTabContextProvider from '../../../../../../components/SelectTabContext/SelectTabContext';
import {getAllReportCreatedForData} from '../../../../../../redux/reducers/ReportMaster';
import {filteredCheckedData, tempSelectFunc} from '../../../../../../util/Functions';
const SearchDataRepositories = ({
  setTabValue = () => {},
  setFieldListRowData,
  setUsageState = () => {},
  usageState,
  eventTrigger,
  allSortFields,
  setRowSelected,
  setIsCopyData,
  StepperFieldList,
  setShowSearch,
  setFieldListCode,
  fieldList,
  setFieldList,
  isLoading,
  deleteSql,
  isReportsFilter,
  isReports,
  sortFields,
  setSortFields,
  selectedRows,
  setFieldValue,
  setSelectedRows,
  isGlobalFieldList,
  resultExpCondition,
  reportFieldsDeleteIdsRef,
  sortFieldsDeleteIdsRef,
  resultRef,
  linkedCategory,
  filterValues,
  fieldsDeleteIdsRef,
  mapFields,
  handleClose,
  tempSelectedRows,
  setTempSelectedRows,
  setReportFieldValue,
  addAccountUpdate,
  setSelectedGlobalField,
  handleEventTacticSearch,
  workQueue,
  handleDirty,
  setFormulaFields,
  formulaFields,
  setFilterFields,
  filterFields,
  isTriggers,
  isFormulaTrue,
  isDataManager,
  dmValues,
  isDMRTrue,
  deletedSelectedFields,
  isDMTrue,
  deletedIds,
  setDeletedIds,
  dmRecordCategory,
  setIntermediateField,
  intermediateField,
  handleSelectTriggerField,
  selectedRepoField,
  setSelectedField,
  setAllSortFields,
  setSortFieldsReset,
  resetSortFields,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState({fieldListCode: fieldList ? fieldList : ''});
  const [saveData, setSaveData] = useState(selectedRepoField ? selectedRepoField : []);
  const [submit, setSubmit] = useState(false);
  const {baseCategoryData, fieldListDataUsage} = useSelector(
    ({addFieldList}) => addFieldList,
  );
  const [customError, setCustomError] = useState(false);
  const [usage, setUsage] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isUsage, setIsUsage] = useState(false);
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const {setSample} = useContext(SelectTabContextProvider);
  const tempUnCheckedRef = useRef([]);
  const {basicInfoData, category} = useSelector(({addRuleGroup}) => addRuleGroup);


  useEffect(() => {
    dispatch(getFieldType());
  }, []);
  const filteredCategory = baseCategoryData?.filter((item) => item?.categoryCode !== 'AR');

  const getCategoryObject = (value, data) => {
    const category = data && data?.filter((i) => i?.categoryCode === value);
    if (category?.length > 0) {
      return category[0];
    }
  };
  useEffect(() => {
    if (fieldList) {
      setSearchData({...searchData, fieldListCode: fieldList});
    }
  }, [fieldList]);

  useEffect(() => {
    if (category) {
      setSearchData({
        ...searchData,
        baseCategory: category ? getCategoryObject(category, filteredCategory) : {},
      });
    }
  }, [category]);

  // reset data and fetch Base Catagory dropdown data(2700799562)
  useEffect(() => {
    dispatch(resetDataRepo());
    dispatch(resetData());
    dispatch(getBaseCategory());
    dispatch(fetchExistingDataRepositoryNames());
    if (!isReports && setRowSelected && setSample && setIsCopyData) {
      setRowSelected('');
      setSample(false);
      setIsCopyData(false);
    }
  }, []);

  // checking there is usage or not(2700799562)
  useEffect(() => {
    if (fieldListDataUsage?.userMetrix === 'No') {
      deleteUsage ?
        setUserMetrixDelete(false) :
        isDelete ?
          setCustomError(false) :
          setCustomError(true);
      deleteUsage && setIsDelete(true);
      setTimeout(() => {
        setCustomError(false);
      }, 3000);
    } else if (fieldListDataUsage?.userMetrix === 'Yes') {
      deleteUsage && setIsDelete(true);
      deleteUsage && setUserMetrixDelete(true);
      !isDelete && !deleteUsage && setUsageState(true);
      !isDelete && !deleteUsage && setTabValue(2);
      setUserMetrixDelete(true);
    }
  }, [fieldListDataUsage]);

  // reset state(2700799562)
  useEffect(() => {
    if (!isReports) {
      setUsageState(false);
      setTabValue(0);
      setIsDelete(false);
    }
    setCustomError(false);
  }, []);
  const SearchSessionRepository = JSON.parse(sessionStorage.getItem('Repository'));


  // form initialvalues(2700799562)
  const initialValues = {
    repoType: '',
    repoName: '',
    repoDescription: '',
    category:
      addAccountUpdate || dmRecordCategory ?
        dmRecordCategory :
        isFormulaTrue ?
          getCategoryObject(basicInfoData?.category, baseCategoryData) :
          '',
    tableName: '',
    fieldName: '',
    fieldType: '',
    createdBy: '',
    createdDate: null,
  };

  // set search Data(2700799562)
  const handleSubmit = (values) => {
    // setSearchFlag(true);
    setSearchData(values);
    setSubmit(true);
    // sessionStorage.setItem("Repository", JSON.stringify(values));
  };

  useEffect(() => {
    if (addAccountUpdate) {
      setSearchData({
        ...searchData,
        category: {categoryCode: 'CO', categoryName: 'Core'},
      });
    }
  }, [addAccountUpdate]);
  useEffect(() => {
    if (basicInfoData) {
      setSearchData({
        ...searchData,
        category: getCategoryObject(basicInfoData?.category, baseCategoryData),
      });
    }
  }, [basicInfoData]);
  useEffect(() => {
    setSearchData({
      ...searchData,
      category: linkedCategory || dmRecordCategory,
    });
  }, [isGlobalFieldList, linkedCategory, dmRecordCategory]);

  useEffect(() => {
    dispatch(getAllReportCreatedForData());
  }, []);

  return (
    // Removed Card styles for text fields (2700799562)
    <div className={`${isReports && !addAccountUpdate ? 'col-md-12' : ''}`}>
      <Formik
        onSubmit={handleSubmit}
        initialValues={
          SearchSessionRepository && !mapFields && !addAccountUpdate ?
            SearchSessionRepository :
            initialValues
        }
        enableReinitialize
        // validationSchema={schema}
      >
        {() => {
          return (
            // Changes text field variant from outlined to standard (2700799562)
            <div>
              <Form autoComplete="off">
                <ErrorBoundaryForComponents>
                  <div className="form-row  standard-field-textfields new-standard-textfields">
                    <div className={isReports ? 'col-12' : 'col-4'}>
                      <div className="d-flex">
                        {mapFields ? (
                          <div className={`col-12 mb-3`}>
                            <div className="d-flex justify-content-xl-end justify-content-lg-end justify-content-md-end">
                              <Button
                                aria-label="close"
                                variant="outlined"
                                className={`mr-1 reset-btn ${classes.buttonRoot}`}
                                onClick={() => {
                                  setSortFieldsReset(!resetSortFields);
                                  handleClose();
                                }}
                              >
                                Close
                              </Button>
                              <Button
                                aria-label="save"
                                variant="outlined"
                                className={`ml-1 search-btn ${classes.buttonRoot}`}
                                onClick={() => {
                                  const obj = tempSelectFunc(
                                    'repositoryName',
                                    'fieldName',
                                    tempUnCheckedRef,
                                  );

                                  if (setSelectedRows) {
                                    const [newSelectedRows, newUnSelectedRows] =
                                      filteredCheckedData(
                                        selectedRows,
                                        obj,
                                        'repositoryName',
                                        'fieldName',
                                      );
                                    if (
                                      !isGlobalFieldList &&
                                      !isTriggers &&
                                      !isDataManager &&
                                      !isDMRTrue &&
                                      !isDMTrue
                                    ) {
                                      tempSelectedRows.forEach((el) => {
                                        setReportFieldValue(
                                          'fieldHeader' + el.fieldName + el.repositoryName,
                                          el.fieldLabel,
                                        );
                                        setReportFieldValue(
                                          'printSubTotal' + el.fieldName + el.repositoryName,
                                          'N',
                                        );
                                      });

                                      reportFieldsDeleteIdsRef.current = [
                                        ...reportFieldsDeleteIdsRef.current,
                                        newUnSelectedRows?.length > 0 ?
                                          newUnSelectedRows[0]?.reportFieldId :
                                          0,
                                      ];
                                    }

                                    const allSelectedRows = [
                                      ...newSelectedRows,
                                      ...tempSelectedRows,
                                    ];

                                    if (isDMTrue) {
                                      if (newUnSelectedRows.length > 0) {
                                        const allDeleteIds = [];
                                        newUnSelectedRows.forEach((el) => {
                                          if (el.dataManagerRecordId) {
                                            allDeleteIds.push(el.dataManagerRecordId);
                                          }
                                        });
                                        if (allDeleteIds.length > 0) {
                                          deletedSelectedFields.current = [
                                            ...deletedSelectedFields.current,
                                            ...allDeleteIds,
                                          ];
                                        } else {
                                          deletedSelectedFields.current = [
                                            ...deletedSelectedFields.current,
                                            0,
                                          ];
                                        }
                                      }
                                    }
                                    setSelectedRows(allSelectedRows);
                                  }

                                  if (setSortFields) {
                                    const [newSelectedRows, newUnSelectedRows] =
                                      filteredCheckedData(
                                        sortFields,
                                        obj,
                                        'repositoryName',
                                        'fieldName',
                                      );
                                    if (newUnSelectedRows.length > 0) {
                                      const allDeleteSortIds = [];
                                      newUnSelectedRows.forEach((el) => {
                                        if (el.dataManagerSortFieldsId) {
                                          allDeleteSortIds.push(el?.dataManagerSortFieldsId);
                                        }
                                        if (el.reportSortFieldsId) {
                                          allDeleteSortIds.push(el?.reportSortFieldsId);
                                        } if (el?.workqueueSortFieldId) {
                                          allDeleteSortIds.push(el?.workqueueSortFieldId);
                                        }
                                      });
                                      if (allDeleteSortIds.length > 0) {
                                        sortFieldsDeleteIdsRef.current = [
                                          ...sortFieldsDeleteIdsRef.current,
                                          ...allDeleteSortIds,
                                        ];
                                      } else {
                                        sortFieldsDeleteIdsRef.current = [
                                          ...sortFieldsDeleteIdsRef.current,
                                          0,
                                        ];
                                      }
                                    }
                                    setSortFields([...newSelectedRows, ...tempSelectedRows]);
                                  }
                                  if (handleDirty) {
                                    handleDirty(true, 'fixed');
                                  }
                                  setTempSelectedRows && setTempSelectedRows([]);
                                  setSelectedField && setSelectedField(saveData);
                                  handleClose();
                                }}
                              >
                                Save
                              </Button>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </ErrorBoundaryForComponents>
              </Form>
            </div>
          );
        }}
      </Formik>
      <FieldListSearchTable
        allSortFields={allSortFields}
        searchData={searchData}
        setTabValue={setTabValue}
        // searchFlag={searchFlag}
        submit={submit}
        setSubmit={setSubmit}
        setUsage={setUsage}
        usage={usage}
        setFieldListRowData={setFieldListRowData}
        setDeleteUsage={setDeleteUsage}
        setIsDelete={setIsDelete}
        isDelete={isDelete}
        setUsageState={setUsageState}
        usageState={usageState}
        userMetrixDelete={userMetrixDelete}
        setIsUsage={setIsUsage}
        isUsage={isUsage}
        setRowSelected={setRowSelected}
        setUserMetrixDelete={setUserMetrixDelete}
        setIsCopyData={setIsCopyData}
        StepperFieldList={StepperFieldList}
        setShowSearch={setShowSearch}
        setFieldListCode={setFieldListCode}
        setFieldList={setFieldList}
        fieldList={fieldList}
        isReportLoader={isLoading}
        deleteSql={deleteSql}
        isReports={isReports}
        isReportsFilter={isReportsFilter}
        sortFields={sortFields}
        setSortFields={setSortFields}
        selectedRows={selectedRows}
        setFieldValue={setFieldValue}
        setSelectedRows={setSelectedRows}
        isGlobalFieldList={isGlobalFieldList}
        resultExpCondition={resultExpCondition}
        resultRef={resultRef}
        reportFieldsDeleteIdsRef={reportFieldsDeleteIdsRef}
        sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
        linkedCategory={linkedCategory}
        values={filterValues}
        fieldsDeleteIdsRef={fieldsDeleteIdsRef}
        tempSelectedRows={tempSelectedRows}
        setTempSelectedRows={setTempSelectedRows}
        tempUnCheckedRef={tempUnCheckedRef}
        addAccountUpdate={addAccountUpdate}
        setSelectedGlobalField={setSelectedGlobalField}
        handleEventTacticSearch={handleEventTacticSearch}
        workQueue={workQueue}
        mapFields={mapFields}
        setFormulaFields={setFormulaFields}
        formulaFields={formulaFields}
        setFilterFields={setFilterFields}
        filterFields={filterFields}
        isTriggers={isTriggers}
        isDataManager={isDataManager}
        dmValues={dmValues}
        deletedIds={deletedIds}
        setDeletedIds={setDeletedIds}
        isDMRTrue={isDMRTrue}
        setIntermediateField={setIntermediateField}
        intermediateField={intermediateField}
        handleSelectTriggerField={handleSelectTriggerField}
        eventTrigger={eventTrigger}
        setSaveData={setSaveData}
        saveData={saveData}
        selectedRepoField={selectedRepoField}
        setSelectedField={setSelectedField}
        isFormulaTrue={isFormulaTrue}
        setAllSortFields={setAllSortFields}
      />
      {customError && <WarningSnackbar errorMsg={'This Field List is not being used anywhere'} />}
    </div>
  );
};

export default React.memo(SearchDataRepositories);
